import { render, staticRenderFns } from "./user-registration.vue?vue&type=template&id=b4ebaf7a"
import script from "./user-registration.vue?vue&type=script&lang=ts"
export * from "./user-registration.vue?vue&type=script&lang=ts"
import style0 from "./user-registration.vue?vue&type=style&index=0&id=b4ebaf7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports